<template>
  <div class="contact" :style="backgroundStyle">
    <div class="ani logo" swiper-animate-effect="fadeIn" swiper-animate-duration="0.5s">
      <a href="#home" class="logo-pc">
        <img src="../assets/logo2.png">
      </a>
      <a href="#home" class="logo-m">
        <img src="../assets/logo.png">
      </a>
    </div>
    <div class="contact-con">
      <div class="amap-wrapper map-box">
        <div id="mapDiv" class="amap-box" style="width: 100%; height: 100%;"></div>
        <div style="display: none;">
          <div ref="infoWrapper" class="custom-info-window">
            <map-info :info="info"></map-info>
          </div>
        </div>
      </div>

      <div
        class="map-chose ani"
        swiper-animate-effect="fadeInRight"
        swiper-animate-duration="1s" 
        :swiper-animate-delay="isMobile ? '0s' : '0.8s'"
      >
        <div class="chose">
          <h2 
            class="ani" 
            swiper-animate-effect="fadeInUp" 
            swiper-animate-duration="1.5s" 
            :swiper-animate-delay="isMobile ? '0s' : '1.5s'"
          >Contact Us</h2>
          <div class="chose-box">
            <ul>
              <li
                class="ani"
                swiper-animate-effect="fadeInUp"
                swiper-animate-duration="1.5s"
                v-for="(item,index) in mapList"
                :key="index"
                :swiper-animate-delay="isMobile ? (index/5+'s') : (1.5+index/5+'s')"
              >
                <a
                  @click="changeInfo(index);infoAni()"
                  :class="{active:index==isActive}"
                  href="javascript:;"
                >{{item.linkText}}</a>
              </li>
            </ul>
          </div>
          <div
            class="m-info ani"
            swiper-animate-effect="fadeInUp"
            swiper-animate-duration="1.5s"
            swiper-animate-delay="1.8s"
          >
            <p>Address</p>
            <span :class="['animated' ,isAni?'fadeInDown':'fadeInUp']">{{info.infoText.address}}</span>
          </div>
          <div 
            class="email ani"
            swiper-animate-effect="fadeInUp" 
            swiper-animate-duration="2.5s" 
            :swiper-animate-delay="isMobile ? '2.3s' : '3s'"
          >Contact us via email: service@cn-hunicorn.com</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MobileDetect from "mobile-detect";
import MapInfo from "../components/MapInfo";

export default {
  name: "contact",
  components: {
    MapInfo
  },
  data() {
    return {
      isMobile: new MobileDetect(window.navigator.userAgent).phone() !== null,
      mapList: [
        {
          linkText: "SHENZHEN",
          center: [114.117011, 22.545032],
          mapcenter: [115.132219, 22.545043],
          infoText: {
            photo: "../static/info.jpg",
            overseas: [
              {
                phone: "0755-22910536",
                email: "thomas.baccino@cn-hunicorn.com"
              },
              { phone: "0755-25179919", email: "derek.wei@cn-hunicorn.com" }
            ],
            address: "27th Floor, Bldg. D, KK 100 Tower, Luohu, Shenzhen"
          }
        },
        {
          linkText: "QINGDAO ",
          center: [120.382101, 36.064821],
          mapcenter: [121.397121, 36.064797],
          infoText: {
            photo: "../static/info.jpg",
            overseas: [
              {
                phone: "0755-22910536",
                email: "thomas.baccino@cn-hunicorn.com"
              },
              { phone: "0755-25179919", email: "wei@cn-hunicorn.com" }
            ],
            address: "Room2107 Farglory International Plaza,No.26 Hongkong Middle Road, Qingdao, China"
          }
        },
        {
          linkText: "NINGBO ",
          center: [121.553925, 29.885216],
          mapcenter: [122.569136, 29.885224],
          infoText: {
            photo: "../static/info.jpg",
            overseas: [
              { phone: "0755-22910536", email: "baccino@cn-hunicorn.com" },
              { phone: "0755-25179919", email: "derek.wei@cn-hunicorn.com" }
            ],
            address: "Raffles City,500 Dazha South Road, Ningbo"
          }
        },
        {
          linkText: "WUHAN",
          center: [114.28088, 30.588245],
          mapcenter: [115.295912, 30.588209],
          infoText: {
            photo: "../static/info.jpg",
            overseas: [
              { phone: "0755-650454", email: "thomas.baccino@cn-hunicorn.com" },
              { phone: "0755-25179919", email: "derek.wei@cn-hunicorn.com" }
            ],
            address:
              "18F, Building 4, Guanggu Enterprise World, Donghu New Technology Development Zone, Wuhan"
          }
        },
        {
          linkText: "GUANGZHOU ",
          center: [113.338546, 23.120595],
          mapcenter: [114.354047, 23.120562],
          infoText: {
            photo: "../static/info.jpg",
            overseas: [
              {
                phone: "0755-22910536",
                email: "thomas.baccino@cn-hunicorn.com"
              },
              { phone: "0755-25179919", email: "derek.wei@cn-hunicorn.com" }
            ],
            address:
              "Block B, Full Square, No.16 Machang Road, Tianhe District, Guangzhou"
          }
        },
        {
          linkText: "XIAMEN",
          center: [118.085795, 24.516333],
          mapcenter: [119.100924, 24.516324],
          infoText: {
            photo: "../static/info.jpg",
            overseas: [
              {
                phone: "0755-22910536",
                email: "thomas.baccino@cn-hunicorn.com"
              },
              { phone: "0755-25179919", email: "derek.wei@cn-hunicorn.com" }
            ],
            address:
              "Building A, Free Trading Finance Center, YuNan No. 4 street, Xiamen"
          }
        },
        {
          linkText: "DONGGUAN",
          center: [113.590656, 22.858103],
          mapcenter: [114.606212, 22.858092],
          infoText: {
            photo: "../static/info.jpg",
            overseas: [
              {
                phone: "0755-22910536",
                email: "thomas.baccino@cn-hunicorn.com"
              },
              { phone: "0755-25179919", email: "derek.wei@cn-hunicorn.com" }
            ],
            address:
              "GLP Humen Port Modern Logistics Park, Port Avenue Shatian Town, Dongguan"
          }
        },
        {
          linkText: "CHENGDU",
          center: [104.067877, 30.595476],
          mapcenter: [105.08204, 30.595449],
          infoText: {
            photo: "../static/info.jpg",
            overseas: [
              {
                phone: "0755-22910536",
                email: "thomas.baccino@cn-hunicorn.com"
              },
              { phone: "0755-25179919", email: "derek.wei@cn-hunicorn.com" }
            ],
            address:
              "North tower, Interaxx Plaza, No. 111 Tiantai Road, Wuhou, Chengdu"
          }
        }
      ],
      center: [0, 0],
      mapcenter: [0, 0],
      show: false,
      isActive: 0,
      info: {},
      isAni: false
    };
  },
  computed: {
    backgroundStyle() {
      if (this.isMobile) {
        return { 'background-color': '#0b153f' };
      }
      return {};
    },
  },
  methods: {
    initMap() {
      if (!window.T) {
        setTimeout(this.initMap, 100);
        return;
      }
      this.map = new T.Map("mapDiv");
      this.map.disableScrollWheelZoom();

      let icon = new T.Icon({
        iconUrl: '/static/mappoint.png',
        iconSize: new T.Point(48, 48),
        iconAnchor: new T.Point(24, 48)
      });
      
      this.marker = new T.Marker(new T.LngLat(this.center[0], this.center[1]), { icon: icon });
      this.map.addOverLay(this.marker);
      
      this.infoWin = new T.InfoWindow(this.$refs.infoWrapper, { 
        offset: new T.Point(0, -35), 
        closeButton: false,
        autoPan: false
      });
      let markerPos = new T.LngLat(this.center[0], this.center[1]);
      let offsetCenter = new T.LngLat(this.center[0] + (this.isMobile ? 0 : 0.03), this.center[1]);

      this.map.openInfoWindow(this.infoWin, markerPos);
      this.map.centerAndZoom(offsetCenter, 14);
    },
    changeInfo(index) {
      this.isActive = index;
      this.center = this.mapList[index].center;
      this.info = this.mapList[index];

      if (this.map && this.marker && this.infoWin) {
        let markerPos = new T.LngLat(this.center[0], this.center[1]);
        let offsetCenter = new T.LngLat(this.center[0] + (this.isMobile ? 0 : 0.03), this.center[1]);
        
        this.map.centerAndZoom(offsetCenter, 14);
        this.marker.setLngLat(markerPos);
        
        if (this.infoWin.setLngLat) {
          this.infoWin.setLngLat(markerPos);
        } else {
          this.map.openInfoWindow(this.infoWin, markerPos);
        }
      }
    },
    infoAni() {
      this.isAni = !this.isAni;
    }
  },
  created() {
    this.center = this.mapList[0].center;
    this.mapcenter = this.mapList[0].mapcenter;
    this.info = this.mapList[0];
  },
  mounted() {
    const _this = this;
    setTimeout(function() {
      _this.aniEnd = true;
    }, 2000);
    this.$nextTick(() => {
      this.initMap();
    });
  }
};
</script>

<style scoped>
.contact {
  height: 100%;
  padding: 30px 30px 40px 30px;
}
.contact-con {
  height: 100%;
  box-sizing: border-box;
  position: relative;
  box-sizing: border-box;
  overflow: hidden;
}
.map-box {
  width: 100%;
  height: 100%;
}
.custom-info-window {
  width: 300px;
  height: 240px;
  overflow: hidden;
}
.map-chose {
  width: 50%;
  height: 100%;
  background: url(../assets/contact-bg.jpg) no-repeat;
  background-size: cover;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 9999;
}
.map-chose h2 {
  padding: 40px 0 30px 0;
  font-size: 56px;
  text-align: center;
  background: url(../assets/contact.png) no-repeat center;
  background-size: 600px;
  color: #f4f4f4;
}
.map-chose .chose {
  position: absolute;
  width: 100%;
  top: 50%;
  transform: translateY(-50%);
}
.chose-box {
  margin-top: 50px;
  text-align: center;
}
.chose-box a {
  display: inline-block;
  width: 360px;
  height: 50px;
  line-height: 50px;
  color: rgba(255, 255, 255, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.6);
  margin-bottom: 15px;
  position: relative;
  left: 0;
  transition: 0.5s;

}
.chose-box a.active {
  color: #fff;
  border-color: #fff;
  left: -15px;

}
.chose-box a:hover {
  text-decoration: none;
  left: -15px;
}
.email{
  color: #fff;
  text-align: center;
  margin-top: 10px;
  font-size: 16px;
}
.logo-m,
.m-info {
  display: none;
}
.logo-pc{
  display: inline-block;
  background: #fff;
  padding: 10px;
}
@media screen and (max-width: 992px) {
  .contact {
    padding: 0;
    background: url(/static/img/contact-bg.jpg) no-repeat;
    background-size: cover;
  }
  .map-box {
    display: none;
  }
  .map-chose {
    width: 100%;
  }
  .contact-con {
    padding: 0;
  }
  .map-chose h2 {
    font-size: 30px;
    background-size: 80%;
    text-align: center;
    background-position: center;
    padding: 12px 0;
    margin-top: 100px;
  }
  .map-chose .chose {
    top: 0;
    transform: translateY(0);
  }
  .chose-box ul {
    overflow: hidden;
    padding: 0 20px;
  }
  .chose-box li {
    float: left;
    width: 46%;
    margin: 0 2% 0 2%;
  }
  .chose-box a {
    width: 100%;
  }
  .chose-box a.active {
    left: 0;
  }
  .m-info {
    display: block;
    padding: 0 30px;
  }
  .m-info p {
    color: #fff;
    padding: 5px 0 5px 20px;
    font-size: 16px;
    background: url(../assets/address-m.png) no-repeat left;
    background-size: 15px;
    margin-bottom: 0;
  }
  .m-info span {
    color: #fff;
    opacity: 0.5;
  }
  .logo-pc{
    display: none;
  }
  .logo-m {
    display: block;
  }
  .fadeInRight {
    animation: none;
  }
}
</style>

<style>
/* Global override for Tianditu InfoWindow to match legacy Gaode Amap appearance and fix alignment */
.tdt-infowindow {
  z-index: 100000 !important;
}
.tdt-infowindow-content-wrapper {
  padding: 0 !important;
  width: 300px !important;
  height: 240px !important;
  border: none !important;
  border-radius: 0 !important;
  box-shadow: 0 1px 15px rgba(0,0,0,0.3) !important;
}
.tdt-infowindow-content {
  margin: 0 !important;
}
/* Ensure the standard popup arrow is not hidden so it points cleanly to the marker */
.tdt-infowindow-close-button {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/view/Contact.vue